// extracted by mini-css-extract-plugin
export default {"emptyPara":"EmptyCartLoader_emptyPara__8EfSE","mainBox":"EmptyCartLoader_mainBox__f+hmA"};